import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { SmartTablePaginationProps } from './types'

const SmartTablePagination = ({
                                  totalPages,
                                  page,
                                  pageSize,
                                  onPageChange,
                                  onPageSizeChange,
                              }: SmartTablePaginationProps) => {
    const {t} = useTranslation()
    const [internalPageNumber, setInternalPageNumber] = useState(page)
    const [internalPageSize, setInternalPageSize] = useState(pageSize)
    const perPageSizes = [10, 15, 25, 50, 100, 200]

    useEffect(() => {
        setInternalPageNumber(page)
    }, [page])

    return (
        <div className="d-flex justify-content-between fndt_pagination_wrapper">
            {totalPages ? (
                <>
                    <div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination">
                                <li className="page-item">
                                    <button
                                        className="page-link"
                                        disabled={page === 1}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                            event.preventDefault()
                                            if (onPageChange) {
                                                onPageChange(1)
                                            }
                                        }}
                                        title={t('common.table.firstPage')}
                                        aria-label={t('common.table.firstPage')}>
                                        <span aria-hidden="true"><i className="bi bi-chevron-double-left"></i></span>
                                    </button>
                                </li>

                                <li className="page-item">
                                    <button
                                        className="page-link"
                                        disabled={page === 1}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                            event.preventDefault()
                                            if (onPageChange) {
                                                onPageChange(page - 1)
                                            }
                                        }}
                                        title={t('common.table.prevPage')}
                                        aria-label={t('common.table.prevPage')}>
                                        <span aria-hidden="true"><i className="bi bi-chevron-left"></i></span>
                                    </button>
                                </li>

                                <li className="page-item">
                                    <button
                                        className="page-link"
                                        disabled={page === totalPages}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                            event.preventDefault()
                                            if (onPageChange) {
                                                onPageChange(page + 1)
                                            }
                                        }}
                                        title={t('common.table.nextPage')}
                                        aria-label={t('common.table.nextPage')}>
                                        <span aria-hidden="true"><i className="bi bi-chevron-right"></i></span>
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button
                                        className="page-link"
                                        disabled={page === totalPages}
                                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                            event.preventDefault()
                                            if (onPageChange) {
                                                onPageChange(totalPages)
                                            }
                                        }}
                                        title={t('common.table.lastPage')}
                                        aria-label={t('common.table.lastPage')}>
                                        <span aria-hidden="true"><i className="bi bi-chevron-double-right"></i></span>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div>
                        <div className="row g-3 align-items-center">
                            <div className="col-auto">
                                <label
                                    htmlFor="pageInput"
                                    className="col-form-label">
                                    {t('common.table.pageNo')}
                                </label>
                            </div>
                            <div className="col-auto">
                                <form
                                    onSubmit={(e: React.SyntheticEvent) => {
                                        e.preventDefault()
                                        if (onPageChange) {
                                            onPageChange(isNaN(internalPageNumber) ? 1 : internalPageNumber)
                                        }
                                    }}>
                                    <input
                                        type="number"
                                        min={1}
                                        max={totalPages}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setInternalPageNumber(parseInt(event.target.value))
                                        }}
                                        value={internalPageNumber}
                                        id="pageInput"
                                        className="form-control pagination_input_page"
                                    />
                                </form>
                            </div>
                            <div className="col-auto">
                                <span>
                                    {t('common.table.ofTotalPages', {
                                        totalPages: totalPages,
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="row g-3 align-items-center">
                            <div className="col-auto">{t('common.table.pageSize')}</div>
                            <div className="col-auto">
                                <select
                                    name="itemsPerPage"
                                    className="form-select"
                                    value={internalPageSize}
                                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                                        setInternalPageSize(parseInt(event.target.value))
                                        if (onPageSizeChange) {
                                            onPageSizeChange(parseInt(event.target.value))
                                        }
                                    }}>
                                    {perPageSizes.map((pageLength) => (
                                        <option
                                            key={pageLength}
                                            value={pageLength}>
                                            {pageLength}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    )
}

export default SmartTablePagination
